import Vue from 'vue';
import VueRouter from "vue-router";
import Login from "../views/Login";
import Home from "../views/Home";
import User from "../views/User";
import Role from "../views/Role";
import App from "../views/App";
import AStar from "../views/process/AStar";
import RemindConfig from "../views/contract/RemindConfig";
import Flowchart from "../components/flow/Canvas";
import EChartsTest from "../views/EChartsTest";
import Dictionary from "../views/Dictionary";
import DynamicFormTest from "../views/DynamicFormTest";
import BudgetProgress from "../views/project/BudgetProgress";
import Confirm from "../views/psi/sku/import/Confirm";
import Init from "../views/psi/inventory/Init";
import ConfirmSupplier from "../views/psi/supplier/import/Confirm";
import InitSuccess from "../views/psi/inventory/InitSuccess";
import ConfirmCustomer from "../views/customer/import/Confirm";
import UploadSuccess from "../views/psi/sku/import/UploadSuccess";
import ChooseResource from "../views/trip/ChooseResource";
import DynamicEntityDataList from "../views/dynamicentity/data/List";
import Edit from "../views/project/plan/Edit";
import View from "../views/project/plan/View";
import Flow from "../views/Flow";


Vue.use(VueRouter);

const routes = [
    {path: '/', component: Login},
    {path: '/login', component: Login},
    {path: '/aStar', component: AStar},
    {path: '/flowDesign', component: Flowchart},
    {
        path: '/app', component: App, children: [
            {path: 'home', component: Home},
            {path: 'user', component: User},
            {path: 'role', component: Role},
            {path: 'echartsTest', component: EChartsTest},
            {path: 'contract/remindConfig', component: RemindConfig},
            {path: 'trip/chooseResource', component: ChooseResource},
            {path: 'psi/sku/import/confirm', component: Confirm},
			{path: 'psi/supplier/import/confirm', component: ConfirmSupplier},
			{path: 'psi/inventory/Init', component: Init},
			{path: 'psi/sku/import/UploadSuccess', component: UploadSuccess},
			{path: 'psi/inventory/InitSuccess', component: InitSuccess},
			{path: 'customer/import/Confirm', component: ConfirmCustomer},
            {path: 'project/budgetProgress', component: BudgetProgress},
            {path: 'project/plan/edit', component: Edit},
            {path: 'project/plan/view', component: View},
            {path: 'dynamicFormTest', component: DynamicFormTest},
            {path: 'process/flowDesign', component: Flowchart},
            {path: 'dynamicentity/data/list', component: DynamicEntityDataList},
            {path: 'dictionary', component: Dictionary},
            {path: 'Flow', component: Flow}
        ]
    }
];

let router = new VueRouter({
    routes
});
export default router;